import types from "../actionTypes";

export default (
  state = {
    currentPage: 1,
    pageSize: 10,
    totalRows: 0,
    applicants: [],
  },
  action
) => {
  switch (action.type) {
    case types.SET_AIR_EMPLOYEE_BY_MANAGER:
      return Object.assign({}, state, { applicants: action.applicants });
    case types.SET_AIR_TOTAL_ROWS:
      return Object.assign({}, state, { totalRows: action.totalRows });
    case types.SET_AIR_CURRENT_PAGE:
      return Object.assign({}, state, { currentPage: action.currentPage });
    case types.SET_AIR_PAGE_SIZE:
      return Object.assign({}, state, { pageSize: action.pageSize });
    default:
      return state;
  }
};
